import { Observable } from 'rxjs';
import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { pluck } from 'rxjs/operators';
const getSupplyEnquiriesByPkMutation = gql`query supply_enquiries_by_pk($id: uuid!) {
  supply_enquiries_by_pk(id:$id) {
    id
    created_at
    updated_at
    supply_id
    supply {
      id
      name
      image
      supply_brand {
        id
        name
      }
      supply_category{
        id
        name
      }
      supply_sub_category{
        id
        name
      }
    }
    supply_variant_id
    supply_variant{
      id
      title
      image
      actual_price
      selling_price
    }
    message
    attachments
    reply
    reply_attachments
    type
    dental_supplier_id
    dental_supplier{
      id
      name
      email
      phone
    }
    dental_professional_id
    dental_professional{
      id
      name
      email
      phone
    }
    dental_practice_id
    dental_practice {
      id
      name
      email
      phone
    }
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetSupplyEnquiriesByPkService {
  /* ------------------------------- Constructor ------------------------------ */
  constructor(private apollo: Apollo) { }
/* ------------------------ Get Suply Enquiries By Pk ----------------------- */
  getSupplyEnquiriesByPk(id: string) : Observable<any>{
    return this.apollo.use('external').query({
      query: getSupplyEnquiriesByPkMutation,
      variables: {
         id
      }
    }).pipe(pluck('data','supply_enquiries_by_pk'));
  }
}
